export default __webpack_public_path__ + "static/media/job poster.94e2a8b0.svg";